/*
 * @Author: Haotao
 * @Date: 2022-10-17 11:09:11-05 15:05:49
 * @LastEditors: Haotao
 */

export class CnzzStatistic {
  trackPageView(path) {
    if (!window._czc || !path) {
      return;
    }
    window._czc.push(['_trackPageview', path]);
  }
}

export const cnzz = new CnzzStatistic();
